import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-lesson-materials.tsx
var LazyCourseLessonMaterials = lazy(() => import("./course-lesson-materials-ZWmuXXGg.js").then((n) => n.n).then((module) => ({ default: module.CourseLessonMaterials })));
function CourseLessonMaterials(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-materials" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonMaterials, { ...props })
	});
}
function CourseLessonMaterialsContent(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-materials" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonMaterials, { ...props })
	});
}
var useCourseLessonMaterialsContent = () => {
	return useMemo(() => ({ courseLessonMaterials: { component: CourseLessonMaterialsContent } }), []);
};
//#endregion
export { CourseLessonMaterials, useCourseLessonMaterialsContent };
